import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Collection => ');

const fetchCollection = createAction('fetch collection', collectionId => ({ collectionId }));
const fetchCollectionSuccess = createAction('fetch collection success', collection => ({ collection }));
const fetchCollectionFailure = createApiFailureAction('fetch collection failure');

const fetchCollections = createAction('fetch collections');
const fetchCollectionsSuccess = createAction('fetch collections success', collections => ({ collections }));
const fetchCollectionsFailure = createApiFailureAction('fetch collections failure');

const fetchCollectionByExperience = createAction('fetch collection by experience', experienceId => ({
  experienceId,
}));
const fetchCollectionByExperienceSuccess = createAction('fetch collection by experience success', collection => ({
  collection,
}));
const fetchCollectionByExperienceFailure = createApiFailureAction('fetch collection by experience failure');

const fetchContentItemByExperience = createAction(
  'fetch collection by experience and content id',
  (experienceId, contentId) => ({
    experienceId,
    contentId,
  })
);
const fetchContentItemByExperienceSuccess = createAction(
  'fetch collection by experience and content id success',
  collection => ({
    collection,
  })
);
const fetchContentItemByExperienceFailure = createApiFailureAction(
  'fetch collection by experience and content id failure'
);

const openWarningModalForMissingCampaignCollection = createAction(
  'opening warning modal for missing campaigns collection'
);

const saveCollection = createAction(
  'save collection by collection form ID for validation',
  (collection, collectionForm) => ({ collection, collectionForm })
);
const saveCollectionSuccess = createAction('save collection success', collection => ({ collection }));
const saveCollectionFailure = createApiFailureAction('save collection failure');

const applyCollection = createAction(
  'save collection by collection form ID for validation',
  (collection, collectionForm) => ({ collection, collectionForm })
);
const applyCollectionSuccess = createAction('save collection success', collection => ({ collection }));
const applyCollectionFailure = createApiFailureAction('save collection failure');

const deleteCollection = createAction('delete collection', collectionId => ({ collectionId }));
const deleteCollectionSuccess = createAction('delete collection success', collectionId => ({ collectionId }));
const deleteCollectionFailure = createApiFailureAction('delete collection failure');
const closeDeleteCollectionModal = createAction('close delete collection modal');

const clearCollectionContent = createAction(
  'clear content in a collection, optionally keeping seeded content',
  (collectionId, keepSeeded) => ({ collectionId, keepSeeded })
);
const clearCollectionContentSuccess = createAction('clear collection content success');
const clearCollectionContentFailure = createApiFailureAction('clear collection content failure');
const closeClearCollectionModal = createAction('close clear collection modal');

const updateIsLoading = createAction('update isLoading', isLoading => ({ isLoading }));

const setActiveCollection = createAction('set active collection', collection => ({ collection }));
const updateActiveCollection = createAction('update active collection data', collectionData => ({ collectionData }));

const updateCollectionSearch = createAction('update collection search', search => ({ search }));

export default {
  fetchCollection,
  fetchCollectionSuccess,
  fetchCollectionFailure,

  fetchCollections,
  fetchCollectionsSuccess,
  fetchCollectionsFailure,

  fetchCollectionByExperience,
  fetchCollectionByExperienceSuccess,
  fetchCollectionByExperienceFailure,

  fetchContentItemByExperience,
  fetchContentItemByExperienceSuccess,
  fetchContentItemByExperienceFailure,

  openWarningModalForMissingCampaignCollection,

  saveCollection,
  saveCollectionSuccess,
  saveCollectionFailure,

  applyCollection,
  applyCollectionSuccess,
  applyCollectionFailure,

  deleteCollection,
  deleteCollectionSuccess,
  deleteCollectionFailure,
  closeDeleteCollectionModal,

  clearCollectionContent,
  clearCollectionContentSuccess,
  clearCollectionContentFailure,
  closeClearCollectionModal,

  updateIsLoading,
  setActiveCollection,
  updateActiveCollection,
  updateCollectionSearch,
};
